/**
 * Venues that use SVG section covers + click-to-zoom (same pattern as boxoffice).
 * Extend this list as you onboard more venues.
 */
const SECTION_COVER_SLUG_SUBSTRINGS = [
  'nmsu',
  'aggie',
  'pan-american',
  'deep-south-ice-and-sports-complex',
]

export function isSectionCoverVenue(venueSlug) {
  if (!venueSlug || typeof venueSlug !== 'string') return false
  const s = venueSlug.toLowerCase()
  return SECTION_COVER_SLUG_SUBSTRINGS.some((frag) => s.includes(frag))
}
